export const fileAttachmentQueryKeys = {
  base: ['fileAttachment'],
  fileAttachments: (tenantID: string | undefined | null, itemID: string | undefined | null) => [
    ...fileAttachmentQueryKeys.base,
    'fileAttachments',
    tenantID,
    itemID,
  ],
};
